import React from "react";
import "../../Stylesheets/Public/AlertBox.css";

const AlertBox = ({ type = "error", message, onClose }) => {
  if (!message) return null;

  return (
    <div className={`alertbox alertbox--${type}`} role="alert" aria-live="polite">
      <div className="alertbox__content">
        <span className="alertbox__dot" />
        <span className="alertbox__message">{message}</span>
      </div>

      {onClose && (
        <button
          type="button"
          className="alertbox__close"
          onClick={onClose}
          aria-label="Close alert"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default AlertBox;
